import React from 'react';
import { ClientPromoBannerProps } from './types';
import { ClientPromoBannerImage } from './ClientPromoBannerImage';

export const ClientPromoBanner: React.FC<ClientPromoBannerProps> = ({
  className = '',
  desktopImageUrl,
  mobileImageUrl,
  altText,
}) => {
  return (
    <aside
      id="client-promo-banner-container"
      aria-label="Promoción especial para compra de vivienda"
      className={`w-full flex items-center justify-center transition-all ${className}`}
    >
      <ClientPromoBannerImage
        desktopImageUrl={desktopImageUrl}
        mobileImageUrl={mobileImageUrl}
        altText={altText}
      />
    </aside>
  );
};
